declare let mxResources: any;
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class EditorRegistryService {
  resources = {};
  editorUi;

  constructor(private translateSvc: TranslateService) {}

  _init() {
    const $translate = val => {
      return this.translateSvc.instant(val);
    };

    this.resources = {
      addToLegend: $translate('EDITOR.ADD_TO_LEGEND'),
      addStartText: $translate('EDITOR.ADD_START_TEXT'),
      addEndText: $translate('EDITOR.ADD_END_TEXT'),
      addInteraction: $translate('EDITOR.ADD_INTERACTION'),
      deleteInteraction: $translate('EDITOR.DELETE_INTERACTION'),
      drilldown: $translate('EDITOR.DRILLDOWN'),
      importDrilldown: $translate('EDITOR.IMPORT_DIAGRAM_DD'),
      // exportDrilldown: $translate('EDITOR.EXPORT_DRILLDOWN_CONTEXT_MENU_LABEL'),
      useExistingDiagram: $translate('EDITOR.LINK_EXISTING_DIAGRAM_DD'),
      newAgentDrilldown: $translate('EDITOR.NEW_INSTRUCTION_DIAGRAM'),
      addResource: $translate('REPORTS.TYPE_RESOURCE'),
      addAttribute: $translate('EDITOR.ADD_ATTRIBUTE'),
      addFooterText: $translate('EDITOR.ADD_FOOTER_TEXT'),
      makeContainerCard: $translate('EDITOR.MAKE_CONTAINER_CARD'),
      makeNormalCard: $translate('EDITOR.MAKE_NORMAL_CARD'),
      addDrilldown: $translate('EDITOR.ADD_DD'),
      addActivity: $translate('EDITOR.ADD_AC'),
      addCard: $translate('EDITOR.ADD_CARD'),
      addImage: $translate('EDITOR.ADD_IMAGE'),
      addSticker: $translate('EDITOR.ADD_STICKER'),
      addRequirement: $translate('EDITOR.ADD_BUSINESS_REQUIREMENT'),
      generateRequirement: $translate('EDITOR.GENERATE_BUSINESS_REQUIREMENT'),
      generateRequirements: $translate('EDITOR.GENERATE_BUSINESS_REQUIREMENTS'),
      addChange: $translate('EDITOR.ADD_CHANGE_RECORD'),
      generate: $translate('EDITOR.GENERATE'),
      addStory: $translate('EDITOR.ADD_USER_STORY'),
      addLinks: $translate('EDITOR.ADD_LINKS_OPTION'),
      addDocumentation: $translate('EDITOR.ADD_DOCUMENTATION_OPTION'),
      pasteStoryLink: $translate('EDITOR.PASTE_STORY_LINK_OPTION'),
      pasteRequirementLink: $translate('EDITOR.PASTE_REQUIREMENT_LINK_OPTION'),
      generateStoriesAI: $translate('EDITOR.GENERATE_USER_STORY'),

      renumberActivity: $translate('EDITOR.RENUMBER_ACT'),
      smartRenumber: $translate('RENUMBER_ACT.SMART'),
      // deleteDrilldown: $translate('EDITOR.DEL_DD'),
      addConnector: $translate('EDITOR.ADD_CONN'),
      addTerminator: $translate('EDITOR.ADD_TERM'),
      removeConnector: $translate('EDITOR.REM_CONN'),
      removeTerminator: $translate('EDITOR.REM_TERM'),
      connectorConnect: $translate('CONNECTOR.CONNECT'),
      connectorCopy: $translate('CONNECTOR.COPY'),
      connectorNav: $translate('CONNECTOR.NAV'),
      connectorDisconnect: $translate('CONNECTOR.DISCONNECT'),
      sendToChild: $translate('EDITOR.SEND_TO_CHILD'),
      autoGenerateDrilldown: $translate('EDITOR.AUTO_GENERATE'),
      alreadyConnected: 'Nodes already connected',
      refModelNode: $translate('EDITOR.REF_M_NODE'),
      orgModelNode: $translate('EDITOR.SALESFORCE_METADATA'),
      copiedOrgModelNode: $translate('EDITOR.ORG_M_NODE'),
      proposedNode: $translate('EDITOR.CREATE_PROPOSED_NODE'),
      requirement: $translate('EDITOR.ATTACH_REQUIREMENT'),
      copyConnectorLink: $translate('CONNECTOR.COPY'),
      pasteConnectorLink: $translate('CONNECTOR.CONNECT'),
      cancel: 'Cancel',
      close: 'Close',
      'collapse-expand': 'Collapse/Expand',
      containsValidationErrors: 'Contains validation errors',
      done: 'Done',
      doubleClickOrientation: 'Doubleclick to change orientation',
      error: 'Error',
      ok: 'OK',
      updatingDocument: 'Updating Document. Please wait...',
      addNote: 'Add note',
      updatingSelection: 'Updating Selection. Please wait...',
      about: 'About',
      add: 'Add',
      addLayer: 'Add layer',
      addAttachment: $translate('EDITOR.ADD_ATTACHMENT'),
      addProperty: 'Add property',
      addToExistingDrawing: 'Add to existing drawing',
      addToBoxes: 'Add to boxes',
      reverseLine: $translate('EDITOR.REVERSE_LINE'),
      choosePoints: $translate('POPUPS.CHOOSE_POINTS_OPTIONS'),
      addWaypoint: $translate('EDITOR.ADD_WP'),
      advanced: 'Advanced',
      align: 'Align',
      alignment: 'Alignment',
      allChangesLost: 'All changes will be lost!',
      angle: 'Angle',
      apply: 'Apply',
      arrange: 'Arrange',
      arrow: 'Arrow',
      arrows: 'Arrows',
      attachDataTable: $translate('EDITOR.ATTACH_DATATABLE'),
      attachNote: $translate('EDITOR.ATTACH_NOTE'),
      attachUrl: $translate('EDITOR.ATTACH_URL'),
      attachImage: $translate('EDITOR.ATTACH_IMAGE'),
      automatic: 'Automatic',
      autosave: 'Autosave',
      autosize: 'Autosize',
      background: 'Background',
      backgroundColor: 'Background color',
      basic: 'Basic',
      bdf: 'BDF',
      bdfMode: 'BDF mode',
      block: 'Block',
      blockquote: 'Blockquote',
      bold: 'Bold',
      borderWidth: 'Borderwidth',
      borderColor: 'Border color',
      bottom: 'Bottom',
      bottomAlign: 'Bottom align',
      bulletedList: 'Bulleted list',
      cannotOpenFile: 'Cannot open file',
      center: 'Center',
      changeOrientation: 'Change orientation',
      circle: 'Circle',
      classic: 'Classic',
      clearDefaultStyle: 'Clear default style',
      clearWaypoints: $translate('EDITOR.CLEAR_WP'),
      makeStraight: $translate('EDITOR.MAKE_STRAIGHT'),
      makeAllLinesStraight: $translate('EDITOR.MAKE_ALL_STRAIGHT'),
      clipart: 'Clipart',
      collapse: 'Collapse',
      collapsible: 'Collapsible',
      connect: 'Connect',
      connection: 'Connection',
      connectionPoints: 'Connection points',
      constrainProportions: 'Constrain proportions',
      copy: $translate('EDITOR.COPY'),
      copyConnect: 'Copy on connect',
      create: 'Create',
      curved: 'Curved',
      custom: 'Custom',
      cut: 'Cut',
      dashed: 'Dashed',
      decreaseIndent: 'Descrease indent',
      default: 'Default',
      delete: $translate('EDITOR.DELETE'),
      deleteColumn: 'Delete column',
      deleteRow: 'Delete row',
      diagram: 'Diagram',
      diamond: 'Diamond',
      diamondThin: 'Diamond (thin)',
      direction: 'Direction',
      distribute: 'Distribute',
      divider: 'Divider',
      documentProperties: 'Document properties',
      dotted: 'Dotted',
      drawing: 'Drawing{1}',
      drawingEmpty: 'Drawing is empty',
      drawingMode: 'Drawing mode',
      drawingTooLarge: 'Drawing is too large',
      duplicate: 'Duplicate',
      east: 'East',
      edit: 'Edit',
      editData: 'Edit data',
      editImage: 'Edit image',
      editLink: 'Edit link',
      editMode: 'Edit mode',
      editStyle: 'Edit style',
      editTooltip: 'Edit tooltip',
      enter: 'Enter',
      enterGroup: 'Enter group',
      enterValue: 'Enter value',
      enterName: 'Enter name',
      enterPropertyName: 'Enter property name',
      entityRelation: 'Entity relation',
      exitGroup: 'Exit Group',
      expand: 'Expand',
      export: 'Export',
      exportJson: 'Export JSON',
      file: 'File',
      fileNotFound: 'File not found',
      filename: 'Filename',
      fill: 'Fill',
      fillColor: 'Fill color',
      fitPage: 'One page',
      fitPageWidth: 'Page width',
      fitTwoPages: 'Two pages',
      fitWindow: $translate('EDITOR.FIT'),
      flip: 'Flip',
      flipH: 'Flip horizontal',
      flipV: 'Flip vertical',
      font: 'Font',
      fontFamily: 'Font family',
      fontColor: 'Font color',
      fontSize: 'Font size',
      format: 'Format',
      formatPanel: 'Format panel',
      formatted: 'Formatted',
      formattedText: 'Formatted text',
      general: 'General',
      glass: 'Glass',
      global: 'Global',
      gradient: 'Gradient',
      gradientColor: 'Color',
      grid: 'Grid',
      group: 'Group',
      guides: 'Guides',
      heading: 'Heading',
      height: 'Height',
      help: 'Help',
      hide: 'Hide',
      hideIt: 'Hide {1}',
      hidden: 'Hidden',
      hierarchy: 'Hierarchy',
      home: 'Home',
      horizontal: 'Horizontal',
      horizontally: 'Horizontally',
      horizontalFlow: 'Horizontal flow',
      horizontalTree: 'Horizontal tree',
      html: 'HTML',
      image: 'Image',
      images: 'Images',
      import: 'Import',
      importJson: 'Import JSON',
      increaseIndent: 'Increase indent',
      insert: 'Insert',
      insertColumnBefore: 'Insert column left',
      insertColumnAfter: 'Insert column right',
      insertHorizontalRule: 'Insert horizontal rule',
      insertImage: 'Insert image',
      insertLink: 'Insert link',
      insertRowBefore: 'Insert row above',
      insertRowAfter: 'Insert row below',
      invalidName: 'Invalid name',
      invalidOrMissingFile: 'Invalid or missing file',
      italic: 'Italic',
      layer: 'Layer',
      layers: 'Layers',
      landscape: 'Landscape',
      laneColor: 'Lanecolor',
      layout: 'Layout',
      left: 'Left',
      leftAlign: 'Left align',
      leftToRight: 'Left to right',
      line: 'Line',
      link: 'Link',
      lineend: 'Line end',
      linestart: 'Line start',
      linewidth: 'Linewidth',
      loading: 'Loading',
      lockUnlock: $translate('EDITOR.LOCK'),
      makeDrilldown: 'Make Drilldown',
      manual: 'Manual',
      matchSize: 'Match size',
      middle: 'Middle',
      middleHorizontal: 'Middle (horizontal)',
      middleVertical: 'Middle (vertical)',
      more: 'More',
      moreResults: 'More Results',
      move: 'Move',
      moveSelectionTo: 'Move selection to {1}',
      navigation: 'Navigation',
      new: 'New',
      noColor: 'No color',
      noFiles: 'No files',
      noMoreResults: 'No more results',
      none: 'None',
      noResultsFor: "No results for '{1}'",
      normal: 'Normal',
      north: 'North',
      numberedList: 'Numbered list',
      opacity: 'Opacity',
      open: 'Open',
      openArrow: 'Open arrow',
      openFile: 'Open file',
      openLink: 'Open link',
      openSupported: 'Supported format is .XML files saved from this software',
      openInNewWindow: 'Open in new window',
      openInThisWindow: 'Open in this window',
      options: 'Options',
      organic: 'Organic',
      orthogonal: 'Orthogonal',
      outline: 'Outline',
      oval: 'Oval',
      pages: 'Pages',
      pageView: 'Page view',
      pageScale: 'Page scale',
      pageSetup: 'Page setup',
      paperSize: 'Paper size',
      paste: $translate('EDITOR.PASTE'),
      pattern: 'Pattern',
      perimeter: 'Perimeter',
      plusTooltip: 'Click and drag to connect, hold down Ctrl to reverse direction',
      portrait: 'Portrait',
      position: 'Position',
      posterPrint: 'Poster print',
      preview: 'Preview',
      print: 'Print',
      radialTree: 'Radial tree',
      redo: $translate('EDITOR.REDO'),
      removeFormat: 'Clear formatting',
      removeFromGroup: 'Remove from group',
      removeIt: 'Remove {1}',
      removeWaypoint: $translate('EDITOR.REMOVE_WP'),
      rename: 'Rename',
      renameIt: 'Rename {1}',
      replace: '{1} already exists. Do you want to replace it?',
      replaceExistingDrawing: 'Replace existing drawing',
      reset: 'Reset',
      right: 'Right',
      rightAlign: 'Right align',
      rightToLeft: 'Right to left',
      rotate: 'Rotate',
      rotateTooltip: 'Click and drag to rotate, click to turn by 90 degrees',
      rotation: 'Rotation',
      rounded: 'Rounded',
      save: 'Save',
      saveAs: 'Save as',
      saved: 'Saved',
      scrollbars: 'Scrollbars',
      search: 'Search',
      searchTerms: 'Search Terms',
      selectAll: $translate('EDITOR.SELECT_A'),
      selectEdges: $translate('EDITOR.SELECT_E'),
      selectionMenu: $translate('EDITOR.SELECT_MENU_TITLE'),
      selectFont: 'Select a font',
      selectVertices: $translate('EDITOR.SELECT_V'),
      selectBoxes: $translate('EDITOR.SELECT_BOXES'),
      shadow: 'Shadow',
      shape: 'Shape',
      sharp: 'Sharp',
      simpleArrow: 'Simple arrow',
      size: 'Size',
      solid: 'Solid',
      sourceSpacing: 'Source spacing',
      south: 'South',
      spacing: 'Spacing',
      straight: 'Straight',
      strokeColor: 'Line color',
      style: 'Style',
      subscript: 'Subscript',
      superscript: 'Superscript',
      table: 'Table',
      targetSpacing: 'Target spacing',
      text: 'Text',
      textAlignment: 'Text alignment',
      textOpacity: 'Text opacity',
      // toBack: $translate('EDITOR.BRING_TO_BACK'),
      toFront: $translate('EDITOR.BRING_TO_FRONT'),
      tooltips: 'Tooltips',
      top: 'Top',
      topAlign: 'Top align',
      transparent: 'Transparent',
      turn: 'Turn',
      underline: 'Underline',
      undo: $translate('EDITOR.UNDO'),
      ungroup: 'Ungroup',
      url: 'URL',
      vertical: 'Vertical',
      vertically: 'Vertically',
      verticalFlow: 'Vertical flow',
      verticalTree: 'Vertical tree',
      view: 'View',
      waypoints: 'Waypoints',
      west: 'West',
      width: 'Width',
      widthHeight: 'Both width and height',
      wordWrap: 'Word wrap',
      writingDirection: 'Writing direction',
      zoom: 'Zoom',
      zoomIn: $translate('EDITOR.ZOOM_IN'),
      zoomOut: $translate('EDITOR.ZOOM_OUT'),
      paperStyle: $translate('STICKER.PAPER_STYLE'),
      paperDefault: $translate('STICKER.DEFAULT_PAPER'),
      paperGreen: $translate('STICKER.GREEN_PAPER'),
      paperBlue: $translate('STICKER.BLUE_PAPER'),
      paperRed: $translate('STICKER.RED_PAPER'),
      pasteStyle: $translate('ASIDE_R.PASTE_STYLE'),
      copyStyle: $translate('ASIDE_R.COPY_STYLE'),
      hideStickers: $translate('EDITOR.HIDE_STICKERS'),
      showStickers: $translate('EDITOR.SHOW_STICKERS'),
      filterStickers: $translate('EDITOR.FILTER_NOTES'),
      filterStickersByUser: $translate('EDITOR.FILTER_NOTES_USER'),
      filterStickersByColor: $translate('EDITOR.FILTER_NOTES_COLOR'),
      filterStickersByTag: $translate('EDITOR.FILTER_NOTES_TAG'),
      changeFont: $translate('EDITOR.CHANGE_FONT'),
      changeTags: $translate('EDITOR.CHANGE_TAGS'),

      formatLineStyle: $translate('EDITOR.FORMAT_LINE_STYLE'),

      // formatActivityThemes: $translate('EDITOR.FORMAT_ACTIVITY_THEMES'),
      formatCardThemes: $translate('EDITOR.FORMAT_CARD_THEMES'),
      // formatActivityResources: $translate('EDITOR.FORMAT_ACTIVITY_RESOURCES'),
      // formatActivityAttachments: $translate('EDITOR.FORMAT_ACTIVITY_ATTACHMENTS'),

      formatTextThemes: $translate('EDITOR.FORMAT_TEXT_THEMES'),

      formatConnectorThemes: $translate('EDITOR.FORMAT_CONNECTOR_THEMES'),
      // formatConnectorConnections: $translate('EDITOR.FORMAT_CONNECTOR_CONNECTIONS'),

      formatTerminatorThemes: $translate('EDITOR.FORMAT_TERMINATOR_THEMES'),

      addItemLink: $translate('POPUPS.ITEM_LINK_DIAG_TITLE'),

      addToCard: $translate('EDITOR.ACTION_ADD_TO_THIS'),
      exportDrilldown: $translate('EDITOR.ACTION_EXPORT_DRILL_SH'),
      deleteDrilldown: $translate('EDITOR.ACTION_DELETE_DRILL_SH'),
      theme: $translate('EDITOR.ACTION_THEME'),
      themePasteMenu: $translate('EDITOR.ACTION_THEME'),
      placement: $translate('EDITOR.ACTION_PLACEMENT'),
      formatActivityThemes: $translate('EDITOR.ACTION_EDIT_THEME'),
      toBack: $translate('EDITOR.ACTION_BRING_TO_BACK_SH'),
      lock: $translate('EDITOR.ACTION_LOCK'),
      unlock: $translate('EDITOR.ACTION_UNLOCK'),

      resourcePlacement: $translate('EDITOR.ACTION_RESOURCE_PLACEMENT_GROUP'),
      resourcePlacementRow: $translate('EDITOR.ACTION_RESOURCE_PLACEMENT_ROW'),
      resourcePlacementTwo: $translate('EDITOR.ACTION_RESOURCE_PLACEMENT_TWO'),
      resourcePlacementFour: $translate('EDITOR.ACTION_RESOURCE_PLACEMENT_FOUR'),

      lineShape: $translate('EDITOR.ACTION_LINE_SHAPE'),
      addToLine: $translate('EDITOR.ACTION_ADD_TO_LINE'),
      lineDrilldown: $translate('EDITOR.DRILLDOWN'),
      lineTheme: $translate('EDITOR.ACTION_THEME'),

      drilldownMenuTitle: $translate('EDITOR.DRILLDOWN_MENU_TITLE'),
      newDrilldown: $translate('EDITOR.UPN_DRILLDOWN'),
      upnDrilldown: $translate('EDITOR.NEW_DD'),
      agentInstructionDrilldown: $translate('EDITOR.AGENT_INSTRUCTION_DRILLDOWN'),
      agentInteractionDrilldown: $translate('EDITOR.AGENT_INTERACTION_DRILLDOWN'),
      interactionFlowDrilldown: $translate('EDITOR.INTERACTION_FLOW_DRILLDOWN'),
      capabilityDrilldown: $translate('EDITOR.CAPABILITY_DRILLDOWN'),
      dataModelDrilldown: $translate('EDITOR.DATA_MODEL_DRILLDOWN'),
      customerJourneyDrilldown: $translate('EDITOR.CUSTOMER_JOURNEY_DRILLDOWN'),
      systemArchitectureDrilldown: $translate('EDITOR.SYSTEM_ARCHITECTURE_DRILLDOWN')
    };
  }

  initMxResources() {
    this._init();

    for (const i in this.resources) {
      if (this.resources.hasOwnProperty(i)) {
        mxResources.resources[i] = this.resources[i];
      }
    }
  }

  getEditorUI() {
    return this.editorUi;
  }

  getGraph() {
    if (this.editorUi) {
      return (this.editorUi.editor || {}).graph;
    }
  }

  setEditorUI(editorUI) {
    this.editorUi = editorUI;
  }

  getResource(name) {
    return this.resources[name] || '';
  }
}
